<template lang="pug">
  //- 新版会员 头部用户信息
  .open-member-top-container-new
    .open-left
      .top-img-container
        img.top-img(:src="avatarImage")
      .left-content
        .top-title
          .top-hello-word-new 你好，{{versionMap[propVersion]|| '超级'}}会员
          //- 权益发放中 标签
          .top-sign-new(v-if="currentOrderOptType===60") 权益发放中
          //- 运营商专属/试用版 标签
          .top-sign-new(v-else-if="mobileOperatorCustomizeInfoDTO.userGoodsLabel") {{mobileOperatorCustomizeInfoDTO.userGoodsLabel}}
        .open-left-bottom
          .desc-font 累计已省
          .highlight-font {{ processedDiscountAmount }}
          .desc-font {{getUnit}}
          .col-line
          .award-block
            .right-time(v-if="autoRenewalStatus === RENEWAL_STATUS.signed && expirationDate")
              span(v-if="isNextCycleCharged")
                .desc-font {{ nextPeriodBenefitStartTime | time('MM.DD')}}发放次月权益
              span(v-else) {{ expirationDate | time('MM.DD') }}将自动续费
            .right-time(v-else-if="expirationDate")
              span(v-if="isNextCycleCharged")
                .desc-font {{ nextPeriodBenefitStartTime | time('MM.DD')}}发放次月权益
              span(v-else)
                .desc-font {{ expirationDate | time('MM.DD') }}会员到期
    .open-right(v-if="showButtonResult")
      .right-btn-new(v-if="renewBtn()" @click="goRenew") 管理续费
</template>

<script>
import Toast from '@/components/toast';
import { PropVersionMap } from '@/const/vip';
import {
  getNoScroll,
} from '@/utils';
import { env } from '@hb/hbridge';
import { checkShowButton } from '@/utils/vip';

import {
  VERISON_SHOW_MAP,
  RENEWAL_STATUS,
} from '../../../consts';

export default {
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    ride_trial_verison: {
      type: Boolean,
      default: false,
    },
    propVersion: {
      type: String,
      default: '',
    },
    expirationDate: {
      type: Number,
      default: 0,
    },
    discountAmount: {
      type: Number,
      default: 0,
    },
    isNextCycleCharged: {
      type: Boolean,
      default: false,
    },
    nextPeriodBenefitStartTime: {
      type: Number,
      default: 0,
    },
    currentOrderOptType: {
      type: Number,
      default: 0,
    },
    autoRenewalStatus: {
      type: String,
      default: '',
    },
    rideTrialUpgradeAB: {
      type: String,
      default: 'N',
    },
    /** 是否是日日抽新样式 */
    isLotteryNew: {
      type: Boolean,
      default: false,
    },
    /** 用户信息 */
    userInfo: {
      type: Object,
      default: () => { },
    },
    mobileOperatorCustomizeInfoDTO: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: ['freeRightsVersion'],
  data() {
    return {
      versionMap: VERISON_SHOW_MAP,
      RENEWAL_STATUS,
      showButtonResult: true, // 默认显示按钮
    };
  },
  computed: {
    getUnit() {
      if (this.discountAmount > 10000) {
        return '万元';
      }
      return '元';
    },
    /** < 10000 单位元
       * > 10000 单位万元 转为 x.x万元
       * */
    processedDiscountAmount() {
      if (this.discountAmount > 10000) {
        return `${this.discountAmount / 10000}`;
      }
      return this.discountAmount;
    },
    // 获取用户信息头像
    avatarImage() {
      if (this.userInfo.headPortrait) {
        return this.userInfo.headPortrait;
      }
      if (this.userInfo.sex === 0) {
        return 'https://m.hellobike.com/resource/gallery/407/HHfoGZsC_user_headimg_man.webp';
      }
      if (this.userInfo.sex === 1) {
        return 'https://m.hellobike.com/resource/gallery/407/2_-_Gnu-_user_headimg_woman.webp';
      }
      return 'https://m.hellobike.com/resource/helloyun/00061/VWRrB72ZME.png';
    },
  },
  mounted() {
    this.checkShowButton();
  },
  methods: {
    async checkShowButton() {
      const { isWechatMini, isEasyBikeApp } = env;
      const freeRightInWx = this.freeRightsVersion() && isWechatMini;// 微信小程序为免单特权版时，不显示续费入口
      const isOneCentRide = this.propVersion === PropVersionMap.RIDE_ONE_CENT;
      const oneCentRideNotInApp = isOneCentRide && !isEasyBikeApp;// 非app为一分骑特权版时，不显示续费入口
      this.showButtonResult = await checkShowButton() && !freeRightInWx && !oneCentRideNotInApp;
    },
    isladder() {
      if (this.propVersion) {
        return this.propVersion.includes('ladder');
      }
      return false;
    },
    hideButton() {
      if (env.isWechatMini && this.propVersion && this.propVersion) {
        return false;
      }
      return true;
    },
    renewaWayRide() {
      if (this.autoRenewalStatus === RENEWAL_STATUS.handmax) {
        Toast.show('当前会员仅支持连续续费12个月');
        return;
      }
      this.$emit('showRenwalRide');
      getNoScroll(true);
    },
    goRenew() {
      this.$emit('openAutoRenew');
      // this.$router.push({
      //   path: '/vip/super/auto-renew',
      //   query: { goodsGuid: this.goodsGuid, isNew: true },
      // });
    },
    judgeBtn() {
      const { available, handmax } = RENEWAL_STATUS;
      if ([available, handmax].includes(this.autoRenewalStatus)) {
        return true;
      }
      return false;
    },
    renewBtn() {
      if (this.autoRenewalStatus === RENEWAL_STATUS.signed) {
        return true;
      }
      return false;
    },
    getButtonText() {
      // eslint-disable-next-line camelcase
      const { ride_trial_verison, currentOrderOptType, rideTrialUpgradeAB } = this;
      // eslint-disable-next-line camelcase
      if (ride_trial_verison || currentOrderOptType === 60) {
        return rideTrialUpgradeAB === 'Y' ? '升级正式版' : '续费正式版';
      }
      return '立即续费';
    },
  },
};
</script>
  <style lang="less" scoped>
@import '../../../../../styles/index.less';
@import '../../style.less';

.open-member-top-container {
  margin: 0 0.12rem 0.08rem 0.12rem;
  height: 0.71rem;
  border-radius: 0.16rem;
  display: flex;
  justify-content: space-between;
  padding: 0.17rem 0.16rem 0.12rem 0.16rem;
  position: relative;
  background-image: url(https://m.hellobike.com/resource/gallery/61/tKYCOzY2_Group%201707482211.png?x-oss-process=image/quality,q_80) !important;
  background-size: 100% 100% !important;

  .top-sign {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 0.41rem;
    height: 0.16rem;
    line-height: 0.16rem;
    border-radius: 0 0.16rem 0 0.12rem;
    background: #414141;
    // height: 0.17rem;
    color: #fff;
    font-size: 0.1rem;
    font-weight: 600;
    line-height: 0.17rem;
    text-align: center;
    padding: 0.01rem 0.04rem 0.02rem 0.04rem;
    font-size: 0.1rem;
  }

  .open-left {
    .open-left-top {
      display: flex;

      .top-head-img {
        margin-right: 0.05rem;

        img.top-h-img {
          width: 0.18rem;
          height: 0.18rem;
        }
      }

      .top-hello-word {
        font-size: 0.14rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 500;
        color: #242729;
        margin-right: 0.04rem;
      }
    }

    .open-left-bottom {
      .top-left {
        margin-top: 0.02rem;
        display: flex;
        font-size: 0.11rem;

        .left-font {
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          margin-top: 0.05rem;
        }

        .red-font {
          font-size: 0.18rem;
          font-family: DINAlternate-Bold, DINAlternate, sans-serif;
          font-weight: bold;
          color: #441d06;
          line-height: 0.26rem;
          background: linear-gradient(180deg, #ff7027 0%, #fb4816 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin: 0 0.01rem;
        }
      }
    }
  }

  .open-right {
    .auto-time {
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-size: 0.11rem;
      font-weight: 400;
      color: #7d3b2a;
    }

    .right-btn {
      float: right;
      width: 0.66rem;
      height: 0.25rem;
      border-radius: 0.5rem;
      color: #441d06;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-size: 0.1rem;
      font-weight: 400;
      line-height: 0.25rem;
      text-align: center;
      margin-top: 0.05rem;
      background: #fff;
    }
  }
}

.noladder {
  background: linear-gradient(55.09deg, #ffeeb1 4.72%, #fff7d4 89.13%);
}

.open-member-top-container-new {
  margin: 0 0 0.08rem 0;
  height: 0.48rem;
  border-radius: 0.16rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.16rem 0 0.16rem;
  position: relative;
  background-size: 100% 100% !important;

  .right-btn-new {
    position: relative;
    min-width: 0.64rem;
    height: 0.25rem;
    border-radius: 0.06rem;
    color: #441d06;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    font-size: 0.12rem;
    font-weight: 400;
    line-height: 0.25rem;
    text-align: center;
    margin-top: 0.05rem;
    background: rgba(255, 226, 156, 1);
    padding: 0.05rem 0.07rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .open-left {
    display: flex;
    flex: 1;
    align-items: center;
    overflow: hidden;
  }

  .top-hello-word-new {
    font-size: 0.14rem;
    font-weight: 500;
    color: rgba(36, 39, 41, 1);
  }

  .top-img-container {
    display: flex;
    position: relative;
    width: 0.44rem;
    height: 0.44rem;
    border-radius: 0.22rem;
    margin-top: 0.02rem;
    justify-content: center;
    align-items: center;
    background: linear-gradient(45deg, rgba(255, 213, 113, 1), rgba(255, 225, 148, 1), rgba(255, 213, 113, 1));

    &::before {
      content: '';
      position: absolute;
      top: -0.03rem;
      right: -0.05rem;
      height: 0.22rem;
      width: 0.22rem;
      background: url('https://m.hellobike.com/resource/gallery/59/rz4Ruqhl_crown3.png');
      background-repeat: no-repeat;
      background-size: contain;
    }
  }

  .top-img {
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 0.22rem;
  }

  .left-content {
    display: flex;
    flex: 1;
    flex-direction: column;
    margin-left: 0.0839rem;
    justify-content: center;

    .top-title {
      display: flex;
      align-items: center;
    }

    .top-sign-new {
      height: 0.16rem;
      border-radius: 0.15rem;
      padding: 0 0.06rem 0 0.06rem;
      color: rgba(55, 18, 0, 1);
      font-weight: 600;
      line-height: 0.16rem;
      text-align: center;
      font-size: 0.11rem;
      background: linear-gradient(90deg, rgba(255, 226, 156, 1), rgba(255, 251, 242, 1));
      border: 1px solid rgba(255, 242, 212, 1);
      margin-left: 0.05rem;
      display: flex;
      align-items: center;
    }
  }

  .open-left-bottom {
    display: flex;
    align-items: flex-end;
    font-size: 0.11rem;

    .award-block {
      max-width: 1.18rem;
    }
  }

  .desc-font {
    .ellipsis();

    font-size: 0.11rem;
    color: rgba(36, 39, 41, 1);
  }

  .highlight-font {
    color: rgba(36, 39, 41, 1);
    font-size: 0.15rem;
    font-weight: 500;
    margin-left: 0.01rem;
    margin-right: 0.01rem;
    font-family: "DIN Alternate Bold", sans-serif;
  }

  .col-line {
    width: 0.01rem;
    height: 0.1rem;
    background-color: rgba(36, 39, 41, 1);
    margin-left: 0.05rem;
    margin-right: 0.05rem;
    margin-bottom: 0.03rem;
  }
}

.free-rights-version {
  .open-member-top-container-new {
    width: 3.8rem;
    height: 0.78rem;
    padding: 0 0.14rem;
    margin-bottom: -0.14rem;

    .top-img {
      width: 0.4rem;
      height: 0.4rem;
      border-radius: 0.333rem;
    }

    .top-img-new {
      width: 0.4rem;
      height: 0.4rem;
      border-radius: 0.333rem;
      border: 0.02rem solid #ffd571;
    }

    .top-hello-word-new {
      color: #141c2f;
      -webkit-text-stroke-width: 0.002rem;
      -webkit-text-stroke-color: #141c2f;
      font-family: "PingFang SC";
      font-size: 0.15rem;
      font-weight: 400;
    }

    .open-left-bottom {
      height: 0.2rem;

      .col-line {
        background-color: #879099;
      }

      .desc-font {
        color: #879099;
        font-family: "PingFang SC";
        font-size: 0.11rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }

    .open-right {
      text-align: center;
      font-family: "PingFang SC";
      font-size: 0.12rem;
      font-style: normal;
      font-weight: 500;
      line-height: 0.12rem;

      .right-btn-new {
        width: 0.724rem;
        height: 0.28rem;
        flex-shrink: 0;
        border-radius: 0.24rem;
        line-height: 0.28rem;
        border: 0.005rem solid #e3e3e3;
        background: #fff;
        color: #000;
      }
    }
  }
}
  </style>
